import CompanionMaterialItemConstants from './CompanionMaterialItemConstants';
import CalculatorCompanionMaterialConversionHandler from './handlers/CalculatorCompanionMaterialConversionHandler';
import DoNothingCompanionMaterialConversionHandler from './handlers/DoNothingCompanionMaterialConversionHandler';
import ICompanionMaterialConversionHandler from './handlers/ICompanionMaterialConversionHandler';
import ProtractorCompanionMaterialConversionHandler from './handlers/ProtractorCompanionMaterialConversionHandler';
import RulerCompanionMaterialConversionHandler from './handlers/RulerCompanionMaterialConversionHandler';

class CompanionMaterialItemConverterFactory {
  static createCompanionMaterialConversionHandler(key: string): ICompanionMaterialConversionHandler {
    switch (key.toLowerCase()) {
      case CompanionMaterialItemConstants.PROTRACTOR: {
        return new ProtractorCompanionMaterialConversionHandler();
      }
      case CompanionMaterialItemConstants.RULER: {
        return new RulerCompanionMaterialConversionHandler();
      }
      case CompanionMaterialItemConstants.CALCULATOR: {
        return new CalculatorCompanionMaterialConversionHandler();
      }
      default: {
        return new DoNothingCompanionMaterialConversionHandler();
      }
    }
  }
}

export default CompanionMaterialItemConverterFactory;
